import { createFileRoute } from "@tanstack/react-router";
import { TemplatesTable } from "@/components/admin/templates-table";
import { usePageTitle } from "@/hooks/use-page-title";
import { adminTemplatesQueryOptions } from "@/lib/api/admin-templates";

export const Route = createFileRoute("/dashboard/admin/templates/")({
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(adminTemplatesQueryOptions({})),
  component: AdminTemplatesPage,
});

function AdminTemplatesPage() {
  usePageTitle("Admin - Templates");
  return <TemplatesTable />;
}
